import Vue from 'vue';
const MedioAmbienteInstance = new Vue();
export default MedioAmbienteInstance;
